import React from 'react';

const FormHeader = ({
  currentHeaderText,
  animationKey,
  displayedHeaderText,
  step,
  goBack,
}) => {
  return (
    <div className='tw-flex tw-items-center tw-justify-between tw-mb-12'>
      <div
        className='header-text-container'
        data-dd-privacy={step == 'email' ? 'mask' : 'allow'}
      >
        {currentHeaderText && (
          <div
            key={`exit-${animationKey}`}
            className='header-text-exit !tw-whitespace-nowrap tw-font-medium tw-text-[2.5rem] tw-text-zinc-700'
          >
            {currentHeaderText}
          </div>
        )}

        <div
          key={`enter-${animationKey}`}
          className={`tw-font-medium tw-text-[2.5rem] tw-text-zinc-700 ${
            animationKey > 0 ? 'header-text-enter' : ''
          } !tw-whitespace-nowrap`}
        >
          {displayedHeaderText}
        </div>
      </div>

      {step !== 'email' && (
        // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
        <p onClick={goBack} className='subheading_note change'>
          Go Back
        </p>
      )}
    </div>
  );
};

export default FormHeader;
